import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e78f2bec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card Filter-card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "План", -1))
const _hoisted_4 = {
  key: 0,
  class: "Filter-control"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Заказ", -1))
const _hoisted_6 = {
  key: 1,
  class: "Filter-control"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Номенклатура", -1))
const _hoisted_8 = {
  key: 0,
  class: "dx-button-text"
}
const _hoisted_9 = {
  key: 1,
  class: "dx-button-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxButton = _resolveComponent("DxButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          _createVNode(_component_CatalogueSelectControl, {
            filters: [
              { column: 'stateDescription', value: 'Решение найдено' },
            ],
            class: "ModelField-selectControl",
            stylingMode: "outlined",
            id: _ctx.model.planId,
            "onUpdate:id": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.planId) = $event)),
            desc: _ctx.model.planDescription,
            "onUpdate:desc": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.planDescription) = $event)),
            keyField: "id",
            displayDescField: "name",
            catalogueComponentName: "journals/PlanJournal/PlanJournal",
            hasEmptyValue: true,
            onChanged: _ctx.onPlanChange
          }, null, 8, ["id", "desc", "onChanged"])
        ]),
        (_ctx.showOrder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_DxSelectBox, {
                class: "ModelField-control",
                "display-expr": "desc",
                "data-source": _ctx.dataSourceOrder,
                value: _ctx.selectedOrder,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedOrder) = $event)),
                "search-enabled": true,
                stylingMode: "outlined",
                "show-clear-button": true,
                onValueChanged: _ctx.onOrderChange
              }, null, 8, ["data-source", "value", "onValueChanged"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showNomenclature)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_DxSelectBox, {
                class: "ModelField-control",
                "display-expr": "desc",
                "data-source": _ctx.dataSourceNomenclature,
                value: _ctx.selectedNomenclature,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedNomenclature) = $event)),
                "search-enabled": true,
                "show-clear-button": true,
                stylingMode: "outlined"
              }, null, 8, ["data-source", "value"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DxButton, {
          disabled: !_ctx.model.planId,
          class: "Plan-reportButton",
          type: "default",
          onClick: _ctx.onButtonClick,
          "styling-mode": "outlined"
        }, {
          content: _withCtx(() => [
            _createElementVNode("span", null, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Сформировать"))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "Остановить"))
            ])
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}